require('./contractEasyLoan.scss');

const PropTypes = require('prop-types');
//@vendor
const React = require('react');
const { withRouter } = require("react-router-dom");
//@commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@core
const { FormattedText } = require('core/i18n').i18n;
//@components
const ContractEasyLoanStep1 = require('../contractEasyLoan/contractEasyLoanStep1/contractEasyLoanStep1');
const ContractEasyLoanStep2 = require('../contractEasyLoan/contractEasyLoanStep2/contractEasyLoanStep2');
const ContractEasyLoanStep3 = require('./contractEasyLoanStep3/contractEasyLoanStep3');
const ContractEasyLoanStep4 = require('./contractEasyLoanStep4/contractEasyLoanStep4');
//@constants
const { FIRST_STEP } = require('constants/index');
const { NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const {
    catalogue,
    analyticsId,
} = require("./analytics/contractEasyLoan.tracking");
//@utilities
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
class ContractEasyLoan extends React.Component {
    constructor(props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
    }

    onCancel() {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    builDisclaimerText(visibleStep) {
        const showSuperscriptInfo = visibleStep !== FIRST_STEP;
        if (showSuperscriptInfo) {
            return (
                <div className="contract-easy-loan__superscript-info">
                    <FormattedText value="contractEasyLoanStepOne-contractEasyLoanStepOne_superscriptInfo" />
                </div>
            )
        }
    }

    render() {
        const {
            downloadINEDocument,
            downloadPreContractDocument,
            downloanEasyLoanContractDocument,
            getAsnefValidation,
            getBlockedAccounts,
            getHiringDocuments,
            getInstallment,
            immAccounts,
            immContractEasyLoan,
            immFlagBasedFeatures,
            immProfile,
            onDownloadDocument,
            onFinish,
            onPrintDocument,
            preContractualMail,
            requestMinInstallmentQuantity,
            requestProfile,
            resetPrecontractualMail,
            sendMail,
            setLoanAmount,
            setLoanTerm,
            setPaymentDay,
            setPurpose,
            setSelectedAccount,
            setVisibleStep,
            setWillCancel,
            setOfficeStep,
            toggleAgreeCheckbox,
            validateStep,
            getINEDocument,
            getEasyLoanPolicyDocument,
            toggleINEAgreeCheckbox,
            setInitApiFlag,
            onAgreeReset,
            officePrintReset,
            getLoanContractDocuments,
            sendEasyLoanSimpleEmail,
            resetMailSent,
            handleScrolldownPolicy
        } = this.props;
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
        const immSteps = ((!__CONTACT_CENTER__ || isPrintOfficeMode()) && newEasyLoanFF  ) ? immContractEasyLoan.get('fourSteps') : immContractEasyLoan.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immContractEasyLoan.get('visibleStep');
        const disclaimerText = this.builDisclaimerText(visibleStep);
        const isFetchingStepOne = immContractEasyLoan.get('isFetchingInstallment') || immContractEasyLoan.get('minimumInstallmentQuantity') || immContractEasyLoan.get('isFetching');
        const isFetchingStepTwo = immContractEasyLoan.get('fetchingProposition');
        const isFetchingStepThree = newEasyLoanFF ? immContractEasyLoan.get('isFetchingPolicyDocuments') : immContractEasyLoan.get('isFetchingDocuments');
        const maxAmountError = immContractEasyLoan.get('maxAmountError');

        const actions = {
            cancel: this.onCancel,
            finish: onFinish,
            resetStep: () => { 
                (__CONTACT_CENTER__ && !isPrintOfficeMode() &&  immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && !immContractEasyLoan.get('isEasyLoanEmailSent')) ? 
                setInitApiFlag(false,immContractEasyLoan.get('mailAPIFlag'),immContractEasyLoan.get('checkboxFlag'),false):
                setInitApiFlag(false, false, true, false)},
            setVisibleStep,
            setWillCancel,
            validateStep
        };

        let stepOne = <LoadingSection />;
        if (immContractEasyLoan.get('stepReady')) {
            stepOne = (
                <ContractEasyLoanStep1
                    setPurpose={setPurpose}
                    getInstallment={getInstallment}
                    immContractEasyLoan={immContractEasyLoan}
                    immProfile={immProfile}
                    setLoanAmount={setLoanAmount}
                    setLoanTerm={setLoanTerm}
                    downloadPreContractDocument={downloadPreContractDocument}
                    requestMinInstallmentQuantity={requestMinInstallmentQuantity}
                    showTooltip
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    setInitApiFlag={setInitApiFlag}
                    toggleINEAgreeCheckbox={toggleINEAgreeCheckbox}
                    onAgreeReset={onAgreeReset}
                    officePrintReset={officePrintReset}
                    resetMailSent={resetMailSent}
                />
            );
        }

        const tealiumData = [
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_1_VIEW](),
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_2_VIEW]({
                data: immContractEasyLoan.get("minTae"),
            }),
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_3_VIEW]({
                data: immContractEasyLoan.get("minTae"),
            }),
        ];
        const tealiumEvents = [
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_1_SUCCESS](),
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_2_SUCCESS](),
        ];
        return ((!__CONTACT_CENTER__ || isPrintOfficeMode() ) && newEasyLoanFF) ? (
            <React.Fragment>
                <Wizard
                    actions={actions}
                    immSteps={immSteps}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    wizardClass="contract-easy-loan__wizard"
                    tealium={tealiumData[visibleStep - 1]}
                    tealiumEvents={{
                        next: tealiumEvents[visibleStep - 1],
                    }}
                    isTaggingSecondVersion
                >
                    <WizardStep
                        cancelButton
                        isLoading={isFetchingStepOne}
                        nextButtonDisabled={maxAmountError}
                        nextButton
                        position="first"
                    >
                        {stepOne}
                    </WizardStep>
                    <WizardStep
                        cancelButton
                        isLoading={isFetchingStepTwo}
                        nextButton
                        position="middle"
                    >
                        <ContractEasyLoanStep2
                            getBlockedAccounts={getBlockedAccounts}
                            getInstallment={getInstallment}
                            immAccounts={immAccounts}
                            immContractEasyLoan={immContractEasyLoan}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            setPaymentDay={setPaymentDay}
                            setSelectedAccount={setSelectedAccount}
                            getAsnefValidation={getAsnefValidation}
                            beforeStep={immContractEasyLoan.get('beforeStep')}
                            errorAsnef={immContractEasyLoan.get('errorAsnef')}
                            setInitApiFlag={setInitApiFlag}
                            toggleINEAgreeCheckbox={toggleINEAgreeCheckbox}
                            onAgreeReset={onAgreeReset}
                            officePrintReset={officePrintReset}
                            resetMailSent={resetMailSent}
                        />
                    </WizardStep>
                    <WizardStep
                     cancelButton
                     isLoading={isFetchingStepTwo}
                     nextButton
                     position="middle"
                     nextButtonDisabled={isPrintOfficeMode() && newEasyLoanFF ? !immContractEasyLoan.get("officePrintStepThree") : newEasyLoanFF ? (!immContractEasyLoan.get('agreeIneCheckbox') || immContractEasyLoan.get('btnFlag')) : !immContractEasyLoan.get('agreeCheckbox')}
                     >
                     <ContractEasyLoanStep3
                         immContractEasyLoan={immContractEasyLoan}
                         immFlagBasedFeatures={immFlagBasedFeatures}
                         beforeStep={immContractEasyLoan.get('beforeStep')}
                         errorAsnef={immContractEasyLoan.get('errorAsnef')}
                         toggleINEAgreeCheckbox={toggleINEAgreeCheckbox}
                         getINEDocument={getINEDocument}
                         getLoanContractDocuments={getLoanContractDocuments}
                         setOfficeStep={setOfficeStep}
                         previousButton
                         addLoadingBehaviour
                     />
                    </WizardStep>
                    <WizardStep
                        cancelButton
                        finishButton
                        finalButtonDisabled={isPrintOfficeMode() && newEasyLoanFF ? !immContractEasyLoan.get("officePrintStepFour") : newEasyLoanFF ? !immContractEasyLoan.get('agreeIneCheckbox') : !immContractEasyLoan.get('agreeCheckbox')}
                        immFinalButton="contractEasyLoanStepThree-callToActionButton"
                        isLoading={isFetchingStepThree}
                        addLoadingBehaviour
                        position="last"
                        previousButton
                    >
                        <ContractEasyLoanStep4
                            downloadINEDocument={downloadINEDocument}
                            downloanEasyLoanContractDocument={downloanEasyLoanContractDocument}
                            getHiringDocuments={getHiringDocuments}
                            immAccounts={immAccounts}
                            immContractEasyLoan={immContractEasyLoan}
                            immProfile={immProfile}
                            onDownloadDocument={onDownloadDocument}
                            onPrintDocument={onPrintDocument}
                            preContractualMail={preContractualMail}
                            requestProfile={requestProfile}
                            resetPrecontractualMail={resetPrecontractualMail}
                            sendMail={sendMail}                            
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            getINEDocument={getINEDocument}
                            getEasyLoanPolicyDocument={getEasyLoanPolicyDocument}
                            toggleAgreeCheckbox={toggleAgreeCheckbox}
                            setOfficeStep={setOfficeStep}
                            getLoanContractDocuments={getLoanContractDocuments}
                            sendEasyLoanSimpleEmail={sendEasyLoanSimpleEmail}
                            handleScrolldownPolicy={handleScrolldownPolicy}
                        />
                    </WizardStep>
                </Wizard>
                {disclaimerText}
            </React.Fragment>
        ) : (
            <React.Fragment>
                <Wizard
                    actions={actions}
                    immSteps={immSteps}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    wizardClass="contract-easy-loan__wizard"
                    tealium={tealiumData[visibleStep - 1]}
                    tealiumEvents={{
                        next: tealiumEvents[visibleStep - 1],
                    }}
                    isTaggingSecondVersion
                >
                    <WizardStep
                        cancelButton
                        isLoading={isFetchingStepOne}
                        nextButtonDisabled={maxAmountError}
                        nextButton
                        position="first"
                    >
                        {stepOne}
                    </WizardStep>
                    <WizardStep
                        cancelButton
                        isLoading={isFetchingStepTwo}
                        nextButton
                        position="middle"
                    >
                        <ContractEasyLoanStep2
                            getBlockedAccounts={getBlockedAccounts}
                            getInstallment={getInstallment}
                            immAccounts={immAccounts}
                            immContractEasyLoan={immContractEasyLoan}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            setPaymentDay={setPaymentDay}
                            setSelectedAccount={setSelectedAccount}
                            getAsnefValidation={getAsnefValidation}
                            beforeStep={immContractEasyLoan.get('beforeStep')}
                            errorAsnef={immContractEasyLoan.get('errorAsnef')}
                            setInitApiFlag={setInitApiFlag}
                            toggleINEAgreeCheckbox={toggleINEAgreeCheckbox}
                            onAgreeReset={onAgreeReset}
                            resetMailSent={resetMailSent}
                        />
                    </WizardStep>
                    <WizardStep
                        cancelButton
                        finishButton
                        finalButtonDisabled={!immContractEasyLoan.get('agreeCheckbox')}
                        immFinalButton="contractEasyLoanStepThree-callToActionButton"
                        isLoading={__CONTACT_CENTER__ ? isFetchingStepThree : immContractEasyLoan.get('isFetching')}
                        addLoadingBehaviour
                        position="last"
                        previousButton
                    >
                        <ContractEasyLoanStep4
                            downloadINEDocument={downloadINEDocument}
                            downloanEasyLoanContractDocument={downloanEasyLoanContractDocument}
                            getHiringDocuments={getHiringDocuments}
                            immAccounts={immAccounts}
                            immContractEasyLoan={immContractEasyLoan}
                            immProfile={immProfile}
                            onDownloadDocument={onDownloadDocument}
                            onPrintDocument={onPrintDocument}
                            preContractualMail={preContractualMail}
                            requestProfile={requestProfile}
                            resetPrecontractualMail={resetPrecontractualMail}
                            sendMail={sendMail}                            
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            getINEDocument={getINEDocument}
                            getEasyLoanPolicyDocument={getEasyLoanPolicyDocument}
                            toggleAgreeCheckbox={toggleAgreeCheckbox}
                            getLoanContractDocuments={getLoanContractDocuments}
                            sendEasyLoanSimpleEmail={sendEasyLoanSimpleEmail}
                            handleScrolldownPolicy={handleScrolldownPolicy}
                        />
                    </WizardStep>
                </Wizard>
                {disclaimerText}
            </React.Fragment>
        );
    }
}

ContractEasyLoan.propTypes = {
    downloadINEDocument: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    downloanEasyLoanContractDocument: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractEasyLoan: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestMinInstallmentQuantity: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    setImportMaxMin: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setPaymentDay: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleAgreeCheckbox: PropTypes.func.isRequired,
    toggleINEAgreeCheckbox: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    getINEDocument:PropTypes.func.isRequired,
    getEasyLoanPolicyDocument:PropTypes.func.isRequired,
    setOfficeStep:PropTypes.func.isRequired,
    setInitApiFlag: PropTypes.func.isRequired,
    onAgreeReset:PropTypes.func.isRequired,
    officePrintReset:PropTypes.func.isRequired,
    getLoanContractDocuments: PropTypes.func,
    sendEasyLoanSimpleEmail: PropTypes.func,
    resetMailSent: PropTypes.func
};

module.exports = withRouter(ContractEasyLoan);
